import { render, staticRenderFns } from "./ContractListPage.vue?vue&type=template&id=53502d8a&"
import script from "./ContractListPage.vue?vue&type=script&lang=ts&"
export * from "./ContractListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports